import React from 'react';
import { FallbackProps } from 'react-error-boundary';
import { styled } from '@linaria/react';
import GridGlobalStyles from '@daedalus/atlas/foundation/GridGlobalStyles';
import { CssBaseline } from '@daedalus/atlas/helpers/CssBaseline';
import { ThemeNames } from '@daedalus/atlas/themes';
import { CSSThemeProvider } from '@daedalus/atlas/themes/CSSThemeProvider';
import { CrashErrorMessageContainer, ErrorMessage } from '../CrashErrorMessage';
const HeightWrapper = /*#__PURE__*/styled('div')({
  name: "HeightWrapper",
  class: "h1drt8o1",
  propsAsIs: false
});
interface Props extends FallbackProps {
  onClick?: () => void;
  t?: ErrorMessage;
}
export const ErrorBoundaryFallback: React.FC<Props> = ({
  onClick,
  t
}) => {
  return <CSSThemeProvider themeName={ThemeNames.vio} isGlobal>
      <CssBaseline />
      <GridGlobalStyles />
      <HeightWrapper>
        <CrashErrorMessageContainer t={t} onClick={onClick} />
      </HeightWrapper>
    </CSSThemeProvider>;
};

require("./ErrorBoundaryFallback.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ErrorBoundaryFallback.tsx");